import React, { useEffect, useState } from "react";
import stepConnect from "../../../../../assets/step-connect.svg";
import stepIcon from "../../../../../assets/step-icon.svg";
import { useTranslation } from "react-i18next";

const SafetyTips = ({ preview }: any) => {

  const {t} = useTranslation();

  const [safetyInstruction, setSafetyInstruction] = useState<Array<string>>();

  const safetyInstructionForBuyer = [
    t('product_details_19'),
    t('product_details_20'),
    t('product_details_21'),
    t('product_details_22'),
  ];
  
  const safetyInstructionForSeller = [
    t('add_edit_product_20'),
    t('add_edit_product_21'),
    t('add_edit_product_22'),
    t('add_edit_product_23'),
  ];

  useEffect(() => {
    if (preview) {
      setSafetyInstruction(safetyInstructionForSeller);
    } else {
      setSafetyInstruction(safetyInstructionForBuyer);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preview]);

  return (
    <div className="flex flex-col gap-5 my-6">
      <p className="font-medium">{t('add_edit_product_19')}</p>
      <div className="p-5 bg-grey-F9 border-[1px] border-grey-EF rounded-xl">
        {/* <div>
          {safetyInstruction &&
            safetyInstruction?.map((item, index) => (
              <div key={index} className="flex flex-col items-center gap-1">
                <img src={stepIcon} alt="step" />
                {index !== 3 && (
                  <img src={stepConnect} alt="step" className="mb-1" />
                )}
              </div>
            ))}
        </div> */}
        <div className="grid gap-1">
          {safetyInstruction &&
            safetyInstruction?.map((item, index) => (
              <div className="flex gap-3">
                <div key={index} className="grid grid-rows-[auto,1fr] gap-1">
                  <img src={stepIcon} alt="step" className="w-5 min-w-5" />
                  {index !== 3 && (
                    // <img src={stepConnect} alt="step" className="mb-1" />
                    <div className="w-[1px] h-full border border-solid border-grey-BA m-auto"></div>
                  )}
                </div>
                <p key={index} className="mb-[1.75rem] leading-4">
                  {item}
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SafetyTips;
